import React, {useMemo} from 'react';
import {cloneDeep} from 'lodash';
import {Checkbox, TextArea, Table, Button, Dropdown, Input} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './TableFilters';

const weeksDealer = [4, 8];
const disabledField = (row) => !weeksDealer.includes(row.original.idWeek);
const validateEmptyField = (row) => row.original.comment || '';

const handleInputText = ({row, data, handleChange}, event) => {
  const newData = [...data];
  Object.assign(newData[row.index], {'comment': event.target.value});
  handleChange(newData);
};

const handleCheckbox = (cellInfo, handleChange, data) => {
  const value = !cellInfo.original.status ? 1 : 0;
  const newData = [...data];
  Object.assign(newData[cellInfo.index], {'status': value});
  handleChange(newData);
};

const getColumnstable = (handleChange, data) => {
  return [
    {
      'Header': '#',
      'accessor': 'idWeek',
      'width': 50,
    },
    {
      'Header': 'Evento',
      'accessor': 'description',
      'width': 250,
    },
    {
      'Header': 'Contacto',
      'accessor': 'contact',
    },
    {
      'Header': 'Comentario',
      'accessor': 'comment',
      'width': 300,
      'Cell': ({row}) => {
        return (
          <TextArea
            disabled={disabledField(row)}
            rows={1}
            placeholder='Comentario'
            value={validateEmptyField(row)}
            onChange={(e) => handleInputText({row, handleChange, data}, e)}
          />
        );
      },
    },
    {
      'Header': 'Estado',
      'accessor': 'status',
      'Cell': ({row}) => {
        const status = +row.original.status === 0 ? false : true;
        const label = status ? 'Completada' : 'Incompleta';
        return (
          <Checkbox
            disabled={disabledField(row)}
            checked={status}
            label={label}
            onChange={(e) => handleCheckbox(row, handleChange, data)}
          />
        );
      },
    },
    {
      'Header': 'Usuario',
      'accessor': 'user',
    },
    {
      'Header': 'Fecha',
      'accessor': 'date',
    },
  ];
};

const AgencyWaitHappy = ({handleChange, dataTable}) => {
  const clone = cloneDeep(dataTable);
  const columnsTable = getColumnstable(handleChange, clone);
  const data = useMemo(() => clone, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination
  );

  return (
    <Table className='interactive' compact striped {...getTableProps()}>
      <Table.Header>
        {headerGroups.map((headerGroup) => (
          <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`title-${index}`}
                textAlign='center'
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
        {headerGroups.map((headerGroup) => (
          <Table.Row key='filters' id='filters'>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell key={`filter-${index}`} textAlign='center'>
                <Filter column={column} />
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {!page.length && (
          <Table.Row>
            <Table.Cell colSpan={12} textAlign='center'>
              No registra momentos{' '}
            </Table.Cell>
          </Table.Row>
        )}
        {page.length > 0 &&
          page.map((row, i) => {
            prepareRow(row);
            return (
              <Table.Row key={i} {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Table.Cell textAlign='center' {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </Table.Cell>
                  );
                })}
              </Table.Row>
            );
          })}
      </Table.Body>
      {page.length > 0 && (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell textAlign='left'>
              <Button
                className='navigation-button'
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content='Anterior'
              />
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={2} textAlign='right'>
              <span>páginas </span>
              <span>
                <Input
                  className='pages-input'
                  type='number'
                  value={pageIndex + 1}
                  min='1'
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={3} textAlign='left'>
              <Dropdown
                className='page-sizes-selection'
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span>filas</span>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='right'>
              <Button
                className='navigation-button'
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content='Siguiente'
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

export default AgencyWaitHappy;
